export default __webpack_public_path__ + "static/media/blend-graph-on2.dd7084a7.svg";